import { render, staticRenderFns } from "./endCommerce.vue?vue&type=template&id=25fd7e4d&"
import script from "./endCommerce.vue?vue&type=script&lang=js&"
export * from "./endCommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fd7e4d')) {
      api.createRecord('25fd7e4d', component.options)
    } else {
      api.reload('25fd7e4d', component.options)
    }
    module.hot.accept("./endCommerce.vue?vue&type=template&id=25fd7e4d&", function () {
      api.rerender('25fd7e4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/DestinationBusiness/endCommerce.vue"
export default component.exports